import { getAxiosClient } from '~src/api';
import _ from 'lodash';
import { modifyState } from '~src/state';

const mapCardsToDefunto = (cards) => {
  return cards.map((card) => ({
    ...card,
    objectId: card.slug,
    nome: card.firstName,
    cognome: card.lastName,
    data_morte: {
      iso: new Date().toISOString(),
    },
    relation_necrofori: [],
  }));
};

export const fetchCards = async (forceFetch = false) => {
  const httpClient = await getAxiosClient();

  const hasCache = _.has(window.editorLoader, 'cards.items');

  if (!forceFetch && hasCache) {
    return window.editorLoader.cards;
  }

  const params = {
    size: 1000, // TODO: [DEV-329] implement search & pagination
  };

  const response = await httpClient.get(process.env.CARDS_API_URL, {
    params,
  });

  const cards = mapCardsToDefunto(response.data.data);

  modifyState('cards', cards);

  Object.assign(window.editorLoader, { cards });

  return cards;
};
